import React, { useState } from 'react';
import avatar from '../assets/Logo.png';
import { API_URL, secret_key } from '../components/Constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';

const Login = () => {
  const [data, setData] = useState({ email: "", password: "" });
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const newdata = { ...data };
    newdata[e.target.id] = e.target.value;
    setData(newdata);
  };

  const removeError = () => setErrorMessage("");
  const handleRememberMe = () => setRememberMe(!rememberMe);
  const toggleShowPassword = () => setShowPassword(!showPassword);

  const loGin = (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);

    const formData = {
      email: data.email,
      password: data.password,
      rememberMe: rememberMe
    };

    axios.post(`${API_URL}/signin`, formData)
      .then((response) => {
        setErrorMessage("");
        setIsSubmitting(false);
        const encryptedToken = CryptoJS.AES.encrypt(response.data.token, secret_key).toString();
        window.localStorage.setItem('token', encryptedToken);
        const encryptedUser = CryptoJS.AES.encrypt(JSON.stringify(response.data.user), secret_key).toString();
        window.localStorage.setItem('_userdata', encryptedUser);
        window.location.href = '/';
      })
      .catch((error) => {
        console.error(error?.response?.data?.error);
        setErrorMessage("Login Failed");
        setIsSubmitting(false);
      });
  };

  const containerStyle = {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px',
    boxSizing: 'border-box',
};

  const formContainerStyle = {
    background: '#ffffff',
    padding: '40px',
    borderRadius: '10px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
    width: '100%',
    maxWidth: '500px'
  };

  const inputStyle = {
    width: '100%',
    padding: '12px 15px',
    borderRadius: '5px',
    border: '1px solid #ccc',
    fontSize: '1rem'
  };

return (
  <div style={{
    minHeight: '100vh',
    background: 'linear-gradient(to bottom right, #f2f4f8, #e8ecf4)', // Soft, non-straining colors
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px'
  }}>
    <div style={{
      width: '100%',
      maxWidth: '420px',
      background: '#ffffff',
      padding: '40px 30px',
      borderRadius: '16px',
      boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
      animation: 'fadeIn 0.6s ease'
    }}>
      <div style={{ textAlign: 'center', marginBottom: '30px' }}>
        <img src={avatar} alt="Logo" style={{ width: '70px', marginBottom: '15px' }} />
        <h2 style={{ margin: 0, fontWeight: 700, color: '#333' }}>NGUNA BULK SMS</h2>
        <p style={{ fontSize: '0.95rem', color: '#666', marginTop: '10px' }}>
          Reach the right people at the right time with
          <strong> high-speed, reliable Bulk SMS</strong> — perfect for <em>marketing, alerts & more</em>.
        </p>
      </div>

      <form onSubmit={loGin}>
        <div style={{ marginBottom: '20px' }}>
          <input
            type="email"
            id="email"
            placeholder="Email address"
            onChange={handleChange}
            onFocus={removeError}
            required
            style={{
              width: '100%',
              padding: '12px 15px',
              fontSize: '1rem',
              borderRadius: '8px',
              border: '1px solid #ccc',
              outline: 'none',
              backgroundColor: '#f9fafb'
            }}
          />
        </div>

        <div style={{ marginBottom: '20px', position: 'relative' }}>
          <input
            type={showPassword ? "text" : "password"}
            id="password"
            placeholder="Password"
            onChange={handleChange}
            onFocus={removeError}
            required
            style={{
              width: '100%',
              padding: '12px 15px',
              fontSize: '1rem',
              borderRadius: '8px',
              border: '1px solid #ccc',
              outline: 'none',
              paddingRight: '40px',
              backgroundColor: '#f9fafb'
            }}
          />
          <i
            className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}
            onClick={toggleShowPassword}
            title={showPassword ? "Hide Password" : "Show Password"}
            style={{
              position: 'absolute',
              right: '15px',
              top: '50%',
              transform: 'translateY(-50%)',
              cursor: 'pointer',
              color: '#888'
            }}
          />
        </div>

        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
          <input
            type="checkbox"
            id="rememberMe"
            checked={rememberMe}
            onChange={handleRememberMe}
            style={{ marginRight: '10px' }}
          />
          <label htmlFor="rememberMe" style={{ fontSize: '0.9rem', color: '#555' }}>
            Remember Me
          </label>
        </div>

        <button
          type="submit"
          style={{
            width: '100%',
            padding: '12px',
            borderRadius: '8px',
            border: 'none',
            backgroundColor: '#4a90e2',
            color: '#fff',
            fontSize: '1rem',
            fontWeight: 600,
            cursor: 'pointer',
            transition: 'background 0.3s'
          }}
        >
          {isSubmitting ? 'Logging in...' : 'Login'}
        </button>

        {errorMessage && (
          <div style={{
            marginTop: '20px',
            padding: '10px',
            color: '#721c24',
            backgroundColor: '#f8d7da',
            border: '1px solid #f5c6cb',
            borderRadius: '6px'
          }}>
            {errorMessage}
          </div>
        )}

        <div style={{ textAlign: 'center', marginTop: '20px', fontSize: '0.9rem' }}>
          <span style={{ color: '#555' }}>Forgot your password? </span>
          <a href="password_reset" style={{ color: '#4a90e2', textDecoration: 'none', fontWeight: 500 }}>
            Reset Here
          </a>
        </div>
      </form>
    </div>
  </div>
);


};

export default Login;
